/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { MatDateFormats } from '@angular/material/core';

export const MAT_LUXON_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'LLL uuuu',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'LLLL uuuu',
  },
};
